import { isTruthy } from "@dashboard/library";
import { useCall } from "@/hooks/useCall/useCall";
import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";
import { useGetLicenses } from "@/hooks/useGetLicenses/useGetLicenses";

export function useTabsRules() {
  const { call } = useCall();
  const { hasLicense, loading: licensesLoading } = useGetLicenses();

  const hasAiStandardAccess =
    hasLicense("aircall_ai") || hasLicense("ai_assist_pro");
  const { isCallDurationLow } = useCallDurationRule();

  const isExternalCall =
    call?.from?.agentId === undefined && call?.to?.agentId === undefined;

  const shouldDisableInsightsTab =
    isCallDurationLow ||
    call?.type === "voicemail" ||
    call?.transcription?.status !== "available";

  const shouldDisableEvaluationTab = !call?.transcription;

  const shouldHideEvaluationTab = [
    isExternalCall,
    !licensesLoading && !hasAiStandardAccess,
    call?.type === "voicemail",
  ].some(isTruthy);

  const shouldHideInsightsTab =
    call?.type === "voicemail" || (!licensesLoading && !hasAiStandardAccess);

  return {
    shouldDisableInsightsTab,
    shouldDisableEvaluationTab,
    shouldHideEvaluationTab,
    shouldHideInsightsTab,
    shouldRedirectInsights: !licensesLoading && !hasAiStandardAccess,
  };
}
